import { useCfBetaEntrySource } from './cloudflareBetaAccess';

/**
 * Whether this customer is in the automated Cloudflare beta (PRE-3294 / R1).
 *
 * One gate, read wherever a beta surface is drawn, so closing the beta is a
 * single change rather than a copy of the cohort rule on each screen. The rule
 * itself lives in `cloudflareBetaAccess`, which rest-api mirrors from the same
 * shared function.
 */
export const useCloudflareBeta = (): boolean =>
  useCfBetaEntrySource() !== null;
